export default "__VITE_ASSET___xi_djHY__"